import Header from "@/components/Header";
import Hero from "@/components/Hero";
import SEOContent from "@/components/SEOContent";
import About from "@/components/About";
import Services from "@/components/Services";
import Gallery from "@/components/Gallery";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import AppointmentForm from "@/components/AppointmentForm";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";

const Index = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "RoofingContractor",
    "name": "Jacky Couverture",
    "description": "Expert en couverture, rénovation et réparation de toiture à Treillières (44119) et toute la Loire-Atlantique. Intervention rapide, devis gratuit, garantie décennale. Spécialiste tuile, ardoise, zinc, isolation, zinguerie.",
    "url": "https://jacky-couverture.lovable.app",
    "telephone": "+33646702617",
    "email": "jacky.couverture44@gmail.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Treillières",
      "addressLocality": "Treillières",
      "postalCode": "44119",
      "addressRegion": "Loire-Atlantique",
      "addressCountry": "FR"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "47.3294",
      "longitude": "-1.6294"
    },
    "areaServed": [
      {
        "@type": "City",
        "name": "Treillières"
      },
      {
        "@type": "City",
        "name": "Nantes"
      },
      {
        "@type": "City",
        "name": "Saint-Mars-du-Désert"
      },
      {
        "@type": "City",
        "name": "Vigneux-de-Bretagne"
      },
      {
        "@type": "City",
        "name": "Grandchamp-des-Fontaines"
      },
      {
        "@type": "City",
        "name": "Sucé-sur-Erdre"
      },
      {
        "@type": "City",
        "name": "Orvault"
      },
      {
        "@type": "City",
        "name": "La Chapelle-sur-Erdre"
      }
    ],
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "08:00",
        "closes": "18:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": "Saturday",
        "opens": "09:00",
        "closes": "12:00"
      }
    ],
    "image": "https://jacky-couverture.lovable.app/og-image.jpg",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5.0",
      "reviewCount": "47",
      "bestRating": "5",
      "worstRating": "1"
    },
    "paymentAccepted": ["Cash", "Credit Card", "Bank Transfer"],
    "currenciesAccepted": "EUR",
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Services de Couverture et Toiture",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Rénovation Toiture Complète",
            "description": "Réfection complète de toiture tuile, ardoise ou zinc avec garantie décennale. Respect des normes DTU."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Réparation Urgente Toiture",
            "description": "Intervention rapide sous 2h en cas de fuite, tuile cassée ou sinistre. Service d'urgence 7j/7."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Isolation Toiture et Combles",
            "description": "Isolation thermique par l'intérieur ou l'extérieur. Éligible aux aides MaPrimeRénov'."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Zinguerie et Gouttières",
            "description": "Pose et réparation de gouttières, chéneaux, évacuation eaux pluviales en zinc, cuivre ou PVC."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Démoussage et Traitement Hydrofuge",
            "description": "Nettoyage haute pression et application de traitement hydrofuge longue durée (5-10 ans)."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Pose Velux et Fenêtres de Toit",
            "description": "Installation de fenêtres de toit Velux avec étanchéité garantie. Modèles rotation, projection ou motorisés."
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Traitement Charpente",
            "description": "Traitement préventif et curatif contre les insectes xylophages et champignons. Renforcement charpente."
          }
        }
      ]
    },
    "makesOffer": [
      {
        "@type": "Offer",
        "name": "Devis Gratuit",
        "description": "Devis détaillé gratuit sous 24h avec déplacement inclus"
      },
      {
        "@type": "Offer",
        "name": "Intervention Urgence",
        "description": "Service d'urgence disponible 7j/7 avec intervention sous 2h"
      }
    ]
  };

  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="Couvreur Treillières (44) | Jacky Couverture - Rénovation Toiture Loire-Atlantique | Devis Gratuit"
        description="Expert couvreur à Treillières (44119) ⭐ Rénovation, réparation, isolation toiture ⚡ Intervention rapide 7j/7 ✓ Devis gratuit sous 24h ✓ Garantie décennale ☎ 06.46.70.26.17"
        canonical="https://jacky-couverture.lovable.app/"
        keywords="couvreur Treillières, couvreur Loire-Atlantique, couvreur 44, toiture Treillières, rénovation toiture 44, couverture Nantes, réparation toiture urgence, zinguerie 44, isolation toiture professionnelle, démoussage toiture Loire-Atlantique, hydrofuge toiture 44, pose Velux Treillières, ardoise tuile zinc, charpente couverture, couvreur Saint-Mars-du-Désert, couvreur Vigneux-de-Bretagne, couvreur Nantes Nord"
        structuredData={structuredData}
      />
      <Header />
      <main>
        <Hero />
        <SEOContent />
        <About />
        <Services />
        <Gallery />
        <Testimonials />
        <FAQ />
        <AppointmentForm />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
